.subheader {
  background-color: var(--common-white);
}
